import { Directive, forwardRef } from '@angular/core';
import { NG_VALIDATORS, AbstractControl, ValidationErrors, Validator, FormControl } from '@angular/forms';
import { ValidationErrorMessageEnum } from '../constants/ValidationErrorMessageEnum';
import { PatentDraftDataForm } from '../_models/patent-draft-data-form';
@Directive({
   selector: '[maxWordCount]',
   providers: [
     { provide: NG_VALIDATORS, useExisting: MaxWordCountValidator, multi: true }
   ]
})

export class MaxWordCountValidator implements Validator {
validate(c: FormControl): ValidationErrors | null {
  return MaxWordCountValidator.validateWordCount(c);
}

static validateWordCount(control: FormControl):  ValidationErrors{
    let wordCount: number = ((control.value || '').match(/\S+/g) || []).length;
   // console.log(wordCount);
    return wordCount <= 150 ? null : {maxwords: {limit:150, actual:wordCount}};
}
}

